export {
	Short,
	Detailed,
	Interactive,
} from './connected'
